export default "__VITE_ASSET__77467e7f__"